import {
  SET_IS_OPEN,
  SET_LOADING,
} from './mutation_types'

export const mutations = {
  [SET_IS_OPEN] (state, value) {
    state.isOpen = value
  },
  [SET_LOADING] (state, value) {
    state.loading = value
  },
}
